import $ from 'jquery';
import _ from 'underscore';

/**
 * @class a helper for chunking window.dataLayer pushes. this should
 *     only be used for events that could feasibly be chunked (e.g.
 *     product impressions)
 *
 * @param {Function} modifier
 *     this is called before each push -- it should modify the array
 *     of arguments into a cohensive dataLayer-ready events
 */
export function DataLayer (modifier) {
    this.id = Math.floor(Math.random() * 1000);
    this._inner = [];
    this._modifier = modifier;
}

/**
 * internal use function to propagate pushes to `window.dataLayer`
 */
DataLayer.prototype._propagate = _.debounce(function propagate () {
    while (this._inner.length) {
        var event = this._modifier(this._inner.splice(0, 20));
        window.dataLayer.push(event);
    }
}, 500);

/**
 * public interface to DataLayer pushes
 *
 * @param {unknown} value
 */
DataLayer.prototype.push = function push (value) {
    var exists = this._inner.some(function (v) {
        return _.isEqual(v, value);
    });

    if (!exists) this._inner.push(value);

    this._propagate();
}

/**
 * @class a cache of product JSON. the key is an AJAX API url, and the
 *     value is a `$.Deferred()` that resolves to the product JSON. to
 *     access, you should use `cache.get(url).done(product => {})`
 */
export function ProductCache () {
    this._inner = new Map();
}

/**
 * get product JSON from the cache, loading it if it's not loaded yet
 *
 * @param {string} url
 * @returns {PromiseLike<Record<string, unknonwn>>}
*/
ProductCache.prototype.get = function get (url) {
    if (!this._inner.has(url)) {
        this._inner.set(url, $.getJSON(url));
    }

    return this._inner.get(url);
}
